module.exports = __webpack_public_path__ + "assets/img/Instagram-white.12bd42d0.svg";